// Connecteam-style KPI summary cards shared across Time Clock tabs.
export const KpiCard = ({ icon: Icon, label, value, sub, color = '#0073ea', C, testId }) => (
  <div
    data-testid={testId}
    style={{
      background: C.surface,
      border: `1px solid ${C.border}`,
      borderRadius: 16,
      padding: '1rem 1.15rem',
      display: 'flex',
      alignItems: 'center',
      gap: 14,
      minWidth: 0,
      boxShadow: '0 1px 2px rgba(15,23,42,0.04)',
      transition: 'transform 0.15s, box-shadow 0.15s',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(15,23,42,0.08)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 1px 2px rgba(15,23,42,0.04)';
    }}
  >
    <div
      style={{
        width: 44, height: 44, borderRadius: 12,
        background: `${color}16`, color,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Icon size={20} strokeWidth={2.25} />
    </div>
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: '0.68rem', fontWeight: 600, color: C.subtext, textTransform: 'uppercase', letterSpacing: '0.05em', whiteSpace: 'nowrap' }}>
        {label}
      </div>
      <div style={{ fontSize: '1.4rem', fontWeight: 800, color: C.text, lineHeight: 1.25 }}>
        {value}
      </div>
      {sub && <div style={{ fontSize: '0.7rem', color: C.subtext, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{sub}</div>}
    </div>
  </div>
);

export const KpiRow = ({ children, testId }) => (
  <div
    data-testid={testId}
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '0.85rem',
      marginBottom: '1.25rem',
    }}
  >
    {children}
  </div>
);
